module.exports = __webpack_public_path__ + "c46e7e7b60fdef1c773821f984161995.png";